import { FC, useMemo } from 'react';
import { WizardFormData, StepErrors } from '../types';
import SearchDropdown from '../../dropDownInput';

interface StepBUPositionProps {
    formData: WizardFormData;
    errors: StepErrors;
    businessUnits: Array<{ name: string; [key: string]: any }>;
    positions: Array<{ name: string; [key: string]: any }>;
    onChange: (field: keyof WizardFormData, value: any) => void;
}

export const Step2_BUPosition: FC<StepBUPositionProps> = ({
    formData,
    errors,
    businessUnits,
    positions,
    onChange,
}) => {
    const buErrorId = 'bu_id-error';
    const positionErrorId = 'position_id-error';

    const buDropdownData = useMemo(() => {
        return businessUnits.map((bu) => ({ label: bu.name, subLabel: '' }));
    }, [businessUnits]);

    const positionDropdownData = useMemo(() => {
        return positions.map((pos) => ({ label: pos.name, subLabel: '' }));
    }, [positions]);

    const handleBUSelect = (item: { label: string; subLabel: string }, _id: string) => {
        const matched = businessUnits.find((bu) => bu.name === item.label);
        if (matched) {
            onChange('bu_id', String(matched.bu_id ?? matched.id ?? ''));
            onChange('buName', matched.name);
        }
    };

    const handlePositionSelect = (item: { label: string; subLabel: string }, _id: string) => {
        const matched = positions.find((pos) => pos.name === item.label);
        if (matched) {
            onChange('position_id', String(matched.position_id ?? matched.id ?? ''));
            onChange('positionName', matched.name);
        }
    };

    const isBUEmpty = businessUnits.length === 0;

    return (
        <div className="step_bu_position">
            <div className="step_field_group">
                <div className="user_list_title">Select a Business Unit:</div>
                <div
                    style={errors.bu_id ? { border: '1px solid red', borderRadius: '4px' } : undefined}
                    aria-describedby={errors.bu_id ? buErrorId : undefined}
                >
                    <SearchDropdown
                        data={buDropdownData}
                        onSelect={handleBUSelect}
                        selected={formData.buName}
                        id="bu_id"
                        editable={!isBUEmpty}
                    />
                </div>
                {isBUEmpty && (
                    <span className="step_inline_info" style={{ color: '#666', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                        No business units available
                    </span>
                )}
                {errors.bu_id && (
                    <span id={buErrorId} className="step_inline_error" role="alert" style={{ color: 'red', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                        {errors.bu_id}
                    </span>
                )}
            </div>

            <div className="step_field_group">
                <div className="user_list_title">Select a Position:</div>
                <div
                    style={errors.position_id ? { border: '1px solid red', borderRadius: '4px' } : undefined}
                    aria-describedby={errors.position_id ? positionErrorId : undefined}
                >
                    <SearchDropdown
                        data={positionDropdownData}
                        onSelect={handlePositionSelect}
                        selected={formData.positionName}
                        id="position_id"
                        editable={true}
                    />
                </div>
                {errors.position_id && (
                    <span id={positionErrorId} className="step_inline_error" role="alert" style={{ color: 'red', fontSize: '12px', marginTop: '4px', display: 'block' }}>
                        {errors.position_id}
                    </span>
                )}
            </div>
        </div>
    );
};

export default Step2_BUPosition;
